export const DEFAULT_STATUSES = ["to-do", "in-progress"];

export const getStatusFilter = (): string[] => {
  const storedFilter = localStorage.getItem("statusFilter");

  // ✅ Case 1: No key at all → use default
  if (storedFilter === null) {
    return DEFAULT_STATUSES;
  }

  try {
    const parsed = JSON.parse(storedFilter);

    // ✅ Case 2: If stored value is an array → return as is (even empty)
    if (Array.isArray(parsed)) {
      return parsed;
    }

    // ✅ Case 3: Invalid type → fallback to default
    return DEFAULT_STATUSES;
  } catch {
    // ✅ Case 4: Invalid JSON → fallback to default
    return DEFAULT_STATUSES;
  }
};
